import React, { useEffect, useState } from 'react';
import { IconButton, Stack, Typography, Box, TextField, Dialog, DialogContent, DialogTitle, Button } from '@mui/material';

import { IconX } from 'src/libraries/icons';

//
//

const ProgrammeRenameDialog: React.FC<{ 
  currentName: string,
  onRename: (newName: string) => Promise<void>,
  modalOpen: boolean,
  setModalOpen: (isOpen: boolean) => void
}> = ({
  currentName,
  onRename,
  modalOpen,
  setModalOpen
}) => {

  const [isLoading,setLoading] = useState(false);
  const [newName,setNewName] = useState(currentName);

  useEffect(() => setNewName(currentName), [currentName]);

  const handleClose = () => {
    setModalOpen(false);
    setLoading(false);
  }

  let handleSubmit = (event: any) => {
    event.preventDefault();
    setLoading(true);
    onRename(newName).finally(() => handleClose());
  };

  return (
    <Dialog open={modalOpen} onClose={handleClose}>
      <Box>
        <DialogTitle variant='h4' sx={{ m: 0, px: 3, pt: 2 }}>Rename the programme</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 16, color: 'inherit' }}
        >
          <IconX />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography sx={{ mb: 3 }}>
          You can assign a custom name to your programme to make your navigation easier.
        </Typography>
        <form onSubmit={handleSubmit}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            gap={1}
            sx={{ mb: 1, flexFlow: 'row wrap', alignItems: 'center' }}
          >
            <TextField
              name="programmename"
              fullWidth
              type="text"
              size="small"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
            />
          </Stack>

          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              loading={isLoading}
              variant="contained"
              type="submit"
              disabled={!newName}
            >
              Rename
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
);
};

export default ProgrammeRenameDialog;
